/*global _, addiesaas */
export default async (Bus) => {
  const formatters = addiesaas.$fn.formatters
  const prefixes = {
    'playcard': 'FunZone Card',
    'playcard_voucher': 'FunZone Card',
    'playcard_sale': 'FunZone Card',
    'playcard_reload': 'Reload',
  }
  // Cart item display
  const cartItemViewModifier = async (data, item) => {
    const {attributes = {}, payload = {}, type} = item || {}
    const {options: payloadOptions = {}} = payload
    const {location_id} = payloadOptions
    const {product = {}} = attributes
    const {price, balance = {}} = product
    const {bonus_points, points} = balance
    const {extra_cash_enabled} = product // custom amount product
    const itemAttributes = data.attributes || (data.attributes = {})
    const isCustom = !!(1 * extra_cash_enabled)
    const prefix = prefixes[type] ?? 'FunZone Card' // ?? => https://babeljs.io/docs/en/babel-plugin-proposal-nullish-coalescing-operator

    const priceTag = formatters.currency(
      _.toFinite(isCustom ? payloadOptions.extra_cash : price)
    )

    const card = attributes.card || {}
    const maskedNumber = card.maskedNumber
    const creditInfo = []
    if (1 * points) {
      creditInfo.push(points + ' Credits')
      if (1 * bonus_points) {
        creditInfo.push(bonus_points + ' Bonus Credits')
      }
    }
    const subTitle = (maskedNumber ? (maskedNumber + ' ') : '') + creditInfo.join(' + ')

    const location = locations[location_id]

    itemAttributes.title = `${prefix} ${priceTag}`
    itemAttributes.subTitle = subTitle
    itemAttributes.notes = location || ''
  }

  _.forOwn(prefixes, (title, type) => {
    Bus.add(`cart.item.${type}`, cartItemViewModifier)
  })

  const locations = await formatters.getLocations()

}
